import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_autocomplete_filled = _resolveComponent("v-autocomplete-filled")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "default_card_wm ma-4",
    style: {"min-width":"98%"},
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "pt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.user.type,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.type) = $event)),
                          _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeType()))
                        ],
                        items: _ctx.typesList,
                        "item-value": "value",
                        "item-title": (item) => item.text,
                        outlined: "",
                        class: "mx-1",
                        "data-cy": "UserEdition-userType",
                        density: "compact"
                      }, null, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.user.type === 'NATURAL_PERSON')
                        ? (_openBlock(), _createBlock(_component_v_switch, {
                            key: 0,
                            modelValue: _ctx.isUserWithAccount,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isUserWithAccount) = $event)),
                            class: "py-0",
                            label: "Activer le compte",
                            density: "compact",
                            "data-cy": "UserEdition-isUserWithAccount"
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.user.type === 'NATURAL_PERSON')
                ? (_openBlock(), _createBlock(_component_v_form, {
                    key: 0,
                    modelValue: _ctx.formIsValid,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formIsValid) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "pr-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.user.firstname,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.firstname) = $event)),
                                type: "text",
                                label: "Prénom",
                                outlined: "",
                                "hide-details": "",
                                "data-cy": "UserEdition-userFirstname",
                                density: "compact"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "pr-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.user.lastname,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.lastname) = $event)),
                                type: "text",
                                label: "Nom",
                                outlined: "",
                                "hide-details": "",
                                rules: [(v) => !!v || 'Un nom est requis'],
                                "data-cy": "UserEdition-userLastname",
                                density: "compact"
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          (_ctx.isUserWithAccount || _ctx.user.type === 'API_USER')
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "4"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.availableProfiles && _ctx.availableProfiles.length)
                                    ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                        key: 0,
                                        modelValue: _ctx.profileId,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.profileId) = $event)),
                                        items: _ctx.availableProfiles,
                                        "item-title": (item) => _ctx.getProfileName(item),
                                        "item-value": "id",
                                        label: "Profil utilisateur",
                                        outlined: "",
                                        "hide-details": "",
                                        rules: [(p) => (!!p && !!p.length) || 'Sélectionnez un profil'],
                                        density: "compact",
                                        "data-cy": "UserEdition-selectProfile"
                                      }, null, 8, ["modelValue", "items", "item-title", "rules"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_ctx.isUserWithAccount)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            "no-gutters": "",
                            class: "pt-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "4",
                                class: "pr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    modelValue: _ctx.user.email,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.email) = $event)),
                                    type: "text",
                                    outlined: "",
                                    "hide-details": "auto",
                                    label: "Email",
                                    disabled: _ctx.user.id !== '' && !_ctx.forcedWithAccountUser,
                                    rules: [
                                    (email) => _ctx.emailPattern.test(email) || 'Un email est requis',
                                    (email) => !_ctx.alreadyExistEmails[email] || 'L\'email existe déjà',
                                ],
                                    density: "compact",
                                    "data-cy": "UserEdition-email"
                                  }, null, 8, ["modelValue", "disabled", "rules"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "4",
                                class: "pr-2"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.user.company)
                                    ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                        key: 0,
                                        outlined: "",
                                        readonly: "",
                                        "hide-details": "",
                                        type: "text",
                                        label: _ctx.isFromUsersMenu ? 'Société' : 'Dossier',
                                        modelValue: _ctx.user.company.name,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.company.name) = $event)),
                                        density: "compact",
                                        "data-cy": "UserEdition-dossier"
                                      }, null, 8, ["label", "modelValue"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              (_ctx.displayPasswordInput)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        outlined: "",
                                        required: "",
                                        label: "Mot de passe",
                                        type: "password",
                                        modelValue: _ctx.password,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.password) = $event)),
                                        rules: [
                                    (p) =>
                                        (p && p.length >= 4) ||
                                        'Mot de passe requis (4 caractères minimum)',
                                ],
                                        density: "compact"
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.isUserWithAccount && _ctx.user.externalId)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "4",
                                class: "pr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "",
                                    readonly: "",
                                    type: "text",
                                    label: "Identifiant externe",
                                    modelValue: _ctx.user.externalId,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.externalId) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_ctx.showIban)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_v_divider, { class: "my-2" }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createElementVNode("span", { class: "title ml-2" }, "Informations bancaires pour le paiement (Optionnel)", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: _ctx.selectedBankAccount.iban,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedBankAccount.iban) = $event)),
                                      label: "IBAN",
                                      outlined: "",
                                      "hide-details": "",
                                      rules: [_ctx.rules.checkIBAN],
                                      onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onIbanChanged(_ctx.selectedBankAccount))),
                                      onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onInputSetTruncatedIban())),
                                      "data-cy": "UserEdition-IBAN",
                                      density: "compact"
                                    }, null, 8, ["modelValue", "rules"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: _ctx.selectedBankAccount.bic,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedBankAccount.bic) = $event)),
                                      label: "BIC",
                                      outlined: "",
                                      "hide-details": "",
                                      rules: [_ctx.rules.checkBIC],
                                      density: "compact",
                                      "data-cy": "UserEdition-BIC"
                                    }, null, 8, ["modelValue", "rules"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: _ctx.selectedBankAccount.name,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedBankAccount.name) = $event)),
                                      label: "Nom de la banque",
                                      outlined: "",
                                      "hide-details": "",
                                      density: "compact"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : (_openBlock(), _createBlock(_component_v_form, {
                    key: 1,
                    modelValue: _ctx.formIsValid,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formIsValid) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "pr-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.user.lastname,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.user.lastname) = $event)),
                                type: "text",
                                label: "Nom de la société",
                                outlined: "",
                                "hide-details": "",
                                rules: [(v) => !!v || 'Le nom de l\'entreprise est requis'],
                                density: "compact"
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "5",
                            class: "pr-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_autocomplete_filled, {
                                modelValue: _ctx.user.legalForm,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.user.legalForm) = $event)),
                                items: _ctx.legalForms,
                                "item-title": _ctx.formatItemTitle,
                                "item-value": "id",
                                label: "Forme juridique"
                              }, null, 8, ["modelValue", "items", "item-title"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "pr-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.user.siret,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.user.siret) = $event)),
                                type: "text",
                                onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onInputSetTruncatedSiret())),
                                label: "SIRET",
                                outlined: "",
                                "hide-details": "",
                                density: "compact"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.showIban)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_v_divider, { class: "my-1" }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: _ctx.selectedBankAccount.iban,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedBankAccount.iban) = $event)),
                                      label: "IBAN",
                                      outlined: "",
                                      "hide-details": "",
                                      rules: [_ctx.rules.checkIBAN],
                                      onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onIbanChanged(_ctx.selectedBankAccount))),
                                      onInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onInputSetTruncatedIban())),
                                      density: "compact",
                                      "data-cy": "UserEdition-IBAN"
                                    }, null, 8, ["modelValue", "rules"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: _ctx.selectedBankAccount.bic,
                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectedBankAccount.bic) = $event)),
                                      label: "BIC",
                                      outlined: "",
                                      "hide-details": "",
                                      rules: [_ctx.rules.checkBIC],
                                      density: "compact"
                                    }, null, 8, ["modelValue", "rules"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}